import script from "./VoucherCartPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherCartPage.vue?vue&type=script&setup=true&lang=ts"

import "./VoucherCartPage.vue?vue&type=style&index=0&id=10646cb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10646cb4"]])

export default __exports__